import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { SalesComponent } from './sales/sales.component';
import { ServicesComponent } from './services/services.component';
import { PrepressComponent } from './prepress/prepress.component';
import { PlantComponent } from './plant/plant.component';
import { EnvironmentComponent } from './environment/environment.component';
import { ContactComponent } from './contact/contact.component';
import { TeamComponent } from './team/team.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { PrivacypolicyComponent } from './privacypolicy/privacypolicy.component';
import { TermsComponent } from './terms/terms.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SalesComponent,
    ServicesComponent,
    PrepressComponent,
    PlantComponent,
    EnvironmentComponent,
    ContactComponent,
    TeamComponent,
    DownloadsComponent,
    PrivacypolicyComponent,
    TermsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts